import React from 'react';
import { Button as MuiButton, ButtonProps as MuiButtonProps } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledButton = styled(MuiButton)(({ theme }) => ({
  padding: '10px 22px',
  borderRadius: theme.shape.borderRadius,
  textTransform: 'none',
  fontWeight: 600,
  transition: 'transform 180ms ease, box-shadow 180ms ease, background-color 180ms ease',
  '&:hover': {
    transform: 'translateY(-1px)'
  },
  '&.MuiButton-contained': {
    boxShadow: '0 10px 24px rgba(214, 90, 136, 0.22)',
    '&:hover': {
      boxShadow: '0 12px 28px rgba(214, 90, 136, 0.3)'
    }
  },
  '&.MuiButton-outlined': {
    borderWidth: 1.5,
    backgroundColor: 'rgba(255,255,255,0.75)',
    '&:hover': {
      borderWidth: 1.5
    }
  },
}));

export interface ButtonProps extends Omit<MuiButtonProps, 'css'> {
  loading?: boolean;
  to?: string;
  component?: React.ElementType;
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(({ children, loading, ...props }, ref) => {
  return (
    <StyledButton ref={ref} {...props} disabled={loading || props.disabled}>
      {children}
    </StyledButton>
  );
});

Button.displayName = 'Button';

export default Button; 